import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IReqBodyCargarArchivo, IResCargaCalificaciones, IResObtenerArchivoLog, IResObtenerListaArchivos } from 'src/app/interfaces/carga-calificaciones';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CargaCalificacionesService {

  constructor(
    private http: HttpClient
  ) { }

  getHeaders(): HttpHeaders{
    return new HttpHeaders()
  }
  
  getListaArchivos(): Observable<IResObtenerListaArchivos> {
    const url = `${environment.endpointAdministrativo}/v1/carga-calificacion/obtenerListaArchivos`
    return this.http.get<IResObtenerListaArchivos>(url, { headers: this.getHeaders() })
  }

  getArchivoLog(archivoId: number): Observable<IResObtenerArchivoLog> {
    const url = `${environment.endpointAdministrativo}/v1/carga-calificacion/obtenerArchivoLog/${archivoId}`
    return this.http.get<IResObtenerArchivoLog>(url, { headers: this.getHeaders() })
  }

  postCargarArchivo(reqBody: IReqBodyCargarArchivo): Observable<IResCargaCalificaciones> {
    const url = `${environment.endpointAdministrativo}/v1/carga-calificacion/cargarArchivo`
    return this.http.post<IResCargaCalificaciones>(url, reqBody, { headers: this.getHeaders() })
  }
}
